import { useCallback, useEffect, useRef } from 'react';

import {
  FileUploadFn,
  GetFileDownloadUrlFn,
} from 'components/SchemableForm/contexts/SchemableFormFileUploadContext/SchemableFormFileUploadContext';

export const useLocalFileUpload = () => {
  const blobUrlsRef = useRef(new Map<string, string>());

  useEffect(() => {
    const blobUrls = blobUrlsRef.current;
    return () => {
      blobUrls.forEach((url) => URL.revokeObjectURL(url));
      blobUrls.clear();
    };
  }, []);

  const uploadFile: FileUploadFn = useCallback(async (file) => {
    const existingUrl = blobUrlsRef.current.get(file.name);
    if (existingUrl) {
      URL.revokeObjectURL(existingUrl);
    }
    const blobUrl = URL.createObjectURL(file);
    blobUrlsRef.current.set(file.name, blobUrl);
    return { fileName: file.name };
  }, []);

  const getFileDownloadUrl: GetFileDownloadUrlFn = useCallback(async (fileName) => {
    const url = blobUrlsRef.current.get(fileName);
    if (!url) {
      throw new Error(`No local file found for "${fileName}"`);
    }
    return { url };
  }, []);

  return { uploadFile, getFileDownloadUrl };
};
